import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ReportOption } from 'app/core/models/report-option.model';
import { ReportAbstractOptionComponent } from 'app/shared/components/report-abstract-option/report-abstract-option.component';
import { CaptureStatusAndReason } from '../capture-status-and-reason-select/capture-status-and-reason-select.component';
import { CaptureService } from 'app/core/services/capture.service';
import { C } from '@angular/cdk/focus-monitor.d-CvvJeQRc';

export class ReportCaptureStatusAndReasonOption implements ReportOption {
  value: CaptureStatusAndReason[];

  constructor(value) {
    this.value = value;
  }

  toPostData(options = { paramName: 'statusAndReasons' }) {
    return { [options.paramName]: this.buildStatusAndReasonParams() };
  }

  private buildStatusAndReasonParams() {
    return this.value.reduce(
      (accumulator, currentValue) => {
        accumulator[currentValue.status] ||= [];
        accumulator[currentValue.status].push(currentValue.reason);
        return accumulator;
      },
      {}
    )
  }
}

@Component({
  selector: 'app-report-capture-status-and-reason-option',
  templateUrl: './report-capture-status-and-reason-option.component.html',
  styleUrls: ['./report-capture-status-and-reason-option.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => ReportCaptureStatusAndReasonOptionComponent),
    },
  ],
  standalone: false
})
export class ReportCaptureStatusAndReasonOptionComponent extends ReportAbstractOptionComponent implements OnInit {
  selectedCaptureStatusAndReasons;
  availableCaptureStatusAndReasons: CaptureStatusAndReason[];

  constructor(private captureService: CaptureService) {
    super();
  }

  ngOnInit(){
    this.availableCaptureStatusAndReasons = this.captureService.statusAndReasonsForSelect() as CaptureStatusAndReason[];
  }

  onModelChange(model: CaptureStatusAndReason[]) {
    this.model = new ReportCaptureStatusAndReasonOption(this.selectedCaptureStatusAndReasons);
    this.onChangeFn(this.model);
  }
}